export const fileToArrayBuffer = (file?: File) =>
	new Promise<ArrayBuffer | string | null>((resolve, reject) => {
		const reader = new FileReader();

		reader.onload = () => resolve(reader.result);
		reader.onerror = (error) => reject(error);

		if (file) reader.readAsArrayBuffer(file);
	});
